import { render, staticRenderFns } from "./BaseAccordion.vue?vue&type=template&id=5cd02b0d&"
import script from "./BaseAccordion.vue?vue&type=script&lang=ts&"
export * from "./BaseAccordion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports